import PropTypes from "prop-types";
import React, { Reducer } from "react";

import { connect, ConnectedComponent } from "react-redux";

// layouts Format
import VerticalLayout from "../components/VerticalLayout";
import HorizontalLayout from "../components/HorizontalLayout";

// Import scss
import "assets/scss/theme.scss";
import { AppStateContext } from "./AppContext";
import { AppAction, appReducer, AppState } from "./AppReducer";
import AppWrapper from "app/AppWrapper";

const App = (props: any) => {
  const Layout: ConnectedComponent<any, any> = React.useMemo(() => {
    let layoutCls;
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }, [props.layout.layoutType]);

  const [appState, appDispatch] = React.useReducer<
    Reducer<AppState, AppAction>
  >(appReducer, {});

  React.useEffect(() => {
    //write listPath api call here
  }, []);

  return (
    <React.Fragment>
      {/* <SignalRContext.Provider value={signalRService}> */}
      <AppStateContext.Provider value={{ appState, appDispatch }}>
        <AppWrapper>
          <Layout>{props.children}</Layout>
        </AppWrapper>
      </AppStateContext.Provider>
      {/* </SignalRContext.Provider> */}
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = (state: any) => {
  return {
    layout: state.Layout,
    globalState: state.GlobalState,
  };
};

export default connect(mapStateToProps, {})(App);
